module.exports = __webpack_public_path__ + "assets/img/teacher (60).ebf85c88.png";